import { IPatient } from '../interfaces'
import { notification } from 'antd'
import { t } from 'i18next'
import { useState } from 'react'
import { useReceiveServices } from 'services'

const useSearchPatient = () => {
  const [loading, setLoading] = useState(false)
  const [patients, setPatients] = useState<Array<IPatient>>([])
  const { searchPatient } = useReceiveServices()

  const handleOnSearch = (phoneNumber: string) => {
    setLoading(true)
    searchPatient({ query: { phone_number: phoneNumber } })
      .then((res) => {
        if (res._successfully) {
          setPatients(res?.data?.patients || [])
          if (!res?.data || res?.data.patients?.length === 0) {
            notification.warning({ message: t('not-found-patient') })
          }
        }
        if (!res._successfully) {
          notification.error({ message: t('please-enter-phone-exactly') })
        }
      })
      .finally(() => setLoading(false))
  }
  return { loading, patients, handleOnSearch, setLoading }
}

export default useSearchPatient
